/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.CabinMasterResponseDto>>;
export function request(
  params: API.tms.cabinMasterSelfScattered.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterSelfScattered/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
